import { C } from '../colors';
import type { TeoPDF } from '../TeoPDF';

export function addDivider(
  this: TeoPDF,
  { y = this.doc.y, color = C.Divider }: { y?: number; color?: string } = {},
) {
  const bounds = this.getPageBounds();
  this.doc.moveTo(bounds.left, y).lineTo(bounds.right, y).lineWidth(2).stroke(color);
  return this;
}
